function InputGroup({ children }) {
  return <div className="flex flex-col mb-2 md:mb-6">{children}</div>
}

export default InputGroup
